import { render, staticRenderFns } from "./TemporaryCashAllocationReport.vue?vue&type=template&id=4b6a7e74&"
import script from "./TemporaryCashAllocationReport.vue?vue&type=script&lang=js&"
export * from "./TemporaryCashAllocationReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports